import { Image, Linking, StyleSheet, View } from "react-native";
import { fp, spH, spV, wp } from "utils/normalizeV2";

import Heading from "components/Heading";
import ImageView from "../src/image";
import { Images } from "./../src/assets";
import Paragraph from "components/Pharagraph";
import ParentScrollView from "components/ParentScrollView";
import { TouchableOpacity } from "react-native";
import VText from "components/VText";

export default function About() {
    return (
        <ParentScrollView>
            <View style={styles.container}>
                <Heading type="h1" style={styles.aboutHeadingText}>
                    About Vêtir
                </Heading>
                <View style={{ ...styles.aboutTextContainer }}>
                    <VText style={{ ...styles.aboutSubText }}>
                        <Paragraph>
                            Vêtir is where luxury shopping and technology meet. A revolutionary AI-powered smart
                            shopping, digital styling and closet management platform, we bring a highly personalized
                            experience with limitless possibilities. The future of shopping is now—let us empower your
                            style.
                        </Paragraph>
                    </VText>
                    <VText style={styles.aboutSubHeadingText}>For Clients</VText>
                    <VText style={{ ...styles.aboutSubText }}>
                        <Paragraph>
                            We’re here to inform your personal style! Our proprietary technology seamlessly centralizes
                            your closet and simplifies outfitting while curating a personalized shopping feed with the
                            latest designer collections. Interactive shoppable videos, AI-assisted stylist, social
                            integration, and editorial content round out the connected commerce experience right at your
                            fingertips. We also provide complimentary and bespoke 1-on-1 styling services. For more
                            information, please email us at{" "}
                            <VText
                                onPress={() => {
                                    Linking.openURL("mailto:Concierge@vetirapp.com");
                                }}
                                style={{ ...styles.aboutSubText, fontWeight: "450" }}
                            >
                                Concierge@vetirapp.com
                            </VText>
                        </Paragraph>
                    </VText>
                    <Heading type="h5" style={styles.aboutSubHeadingText}>
                        For Personal Stylists and Shoppers
                    </Heading>
                    <VText style={{ ...styles.aboutSubText }}>
                        <Paragraph>
                            Showcase your talent and grow your portfolio with us: Enable your business with the tech
                            tools to manage your clienteling, streamline connection, and track your analytics in real
                            time—we did the hard work for you. For more information, please email us at{" "}
                            <VText
                                onPress={() => {
                                    Linking.openURL("mailto:Stylist@vetirapp.com");
                                }}
                                style={{ ...styles.aboutSubText, fontWeight: "450" }}
                            >
                                Stylist@vetirapp.com
                            </VText>
                        </Paragraph>
                    </VText>
                    <Heading type="h5" style={styles.aboutSubHeadingText}>
                        For Designers & Brands
                    </Heading>
                    <VText style={{ ...styles.aboutSubText }}>
                        <Paragraph>
                            Vêtir is an omni-channel platform that unifies the luxury shopping experience and expands
                            customer reach. For more information, please email us at{" "}
                            <VText
                                onPress={() => {
                                    Linking.openURL("mailto:Designer@vetirapp.com");
                                }}
                                style={{ ...styles.aboutSubText, fontWeight: "450" }}
                            >
                                Designer@vetirapp.com
                            </VText>
                        </Paragraph>
                    </VText>
                </View>
                <View style={{ ...styles.aboutTextContainer, marginTop: spV(0) }}>
                    <View style={styles.aboutImageContainer}>
                        <View>
                            <ImageView
                                alt="Vetir about image"
                                style={{
                                    width: 500,
                                    height: 301,
                                    resizeMode: "cover",
                                    backgroundPosition: "top",
                                    // borderBottomWidth: 20
                                }}
                                source={Images.about}
                            />
                        </View>

                        <View style={styles.ImageTextContainer}>
                            <VText style={styles.founderHeadingText}>Our Founder</VText>
                            <VText style={{ ...styles.founderSubText }}>
                                <Paragraph>
                                    Fashion industry veteran and entrepreneur Kate Davidson Hudson brings her
                                    multi-dimensional experience and sharp vision to Vêtir. As the co-founder of
                                    Editorialist, she paved the way for bridging content with luxury e-commerce and
                                    personal styling services. Davidson Hudson also held previous roles as Chief
                                    Development Officer at LuisaViaRoma, Editor-in-Chief of LVR Magazine, and editor at
                                    both Elle and Harper’s Bazaar.
                                </Paragraph>
                            </VText>
                        </View>
                    </View>
                </View>

                <View style={{ ...styles.aboutTextContainer, marginTop: spV(23) }}>
                    <Heading type="h2" style={styles.aboutHeadingText}>
                        Vêtir in News
                    </Heading>
                    <View style={styles.aboutNewsContainer}>
                        <View style={styles.aboutNewsImageContainer}>
                            <TouchableOpacity
                                onPress={() => {
                                    Linking.openURL(
                                        "https://forbes.com/sites/roxannerobinson/2024/02/24/new-shopping-and-styling-app-vtir--aimed-at-luxurys-top-tier-clients/"
                                    );
                                }}
                            >
                                <ImageView alt="aboutNews1" style={styles.aboutNewsImage} source={Images.aboutNews1} />
                            </TouchableOpacity>
                            <VText
                                onPress={() => {
                                    Linking.openURL(
                                        "https://forbes.com/sites/roxannerobinson/2024/02/24/new-shopping-and-styling-app-vtir--aimed-at-luxurys-top-tier-clients/"
                                    );
                                }}
                                style={styles.aboutNewsText}
                                numberOfLines={2}
                            >
                                New Shopping And Styling App Vêtir Aimed At Luxury’s Top-Tier Clients
                            </VText>
                        </View>
                        <View style={styles.aboutNewsImageContainer}>
                            <TouchableOpacity
                                onPress={() => {
                                    Linking.openURL(
                                        "https://vogue.com/slideshow/vetir-paris-fashion-week-launch-party-2024"
                                    );
                                }}
                            >
                                <ImageView alt="aboutNews2" style={styles.aboutNewsImage} source={Images.aboutNews2} />
                            </TouchableOpacity>
                            <VText
                                onPress={() => {
                                    Linking.openURL(
                                        "https://vogue.com/slideshow/vetir-paris-fashion-week-launch-party-2024"
                                    );
                                }}
                                style={styles.aboutNewsText}
                            >
                                New Luxury Fashion App, Vêtir, Debuts in Paris to Much Fanfare
                            </VText>
                        </View>
                        <View style={styles.aboutNewsImageContainer}>
                            <TouchableOpacity
                                onPress={() => {
                                    Linking.openURL(
                                        "https://wwd.com/fashion-news/designer-luxury/vetir-wme-fashion-hudson-yards-fashion-shows-shopping-experience-1236499788/"
                                    );
                                }}
                            >
                                <ImageView alt="aboutNews3" style={styles.aboutNewsImage} source={Images.aboutNews3} />
                            </TouchableOpacity>
                            <VText
                                onPress={() => {
                                    Linking.openURL(
                                        "https://wwd.com/fashion-news/designer-luxury/vetir-wme-fashion-hudson-yards-fashion-shows-shopping-experience-1236499788/"
                                    );
                                }}
                                style={styles.aboutNewsText}
                            >
                                Shopping App Vêtir, WME Fashion and Hudson Yards Partner for Fashion S...
                            </VText>
                        </View>
                    </View>
                </View>
            </View>
        </ParentScrollView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: "white",
        paddingBottom: spV(40),
        width: "auto",
        marginTop: spV(32),
    },
    aboutTextContainer: {
        alignItems: "left",
        textAlign: "left",
        paddingHorizontal: spH(60),
        marginTop: spV(10),
        marginLeft: spH(60),
        marginRight: spH(60),
        // marginBottom:spV(10),
    },
    aboutHeadingText: {
        textAlign: "center",
        fontSize: fp(28),
        fontFamily: "LibreBodoni",
        fontWeight: "350",
        // marginTop: spV(31),
        // fontFamily: "LibreBodoni",
        // fontSize: fp(32),
        // textAlign: "center",
        // fontWeight: "400",
    },
    aboutSubHeadingText: {
        marginTop: spV(25),
        // marginBottom: spV(10),
        fontSize: fp(17),
        fontWeight: "400",
        textAlign: "left",
    },

    aboutSubText: {
        marginTop: spV(8),
        fontSize: fp(14),
        fontWeight: "350",
        textAlign: "left",
        lineHeight: 25,
    },

    aboutImageContainer: {
        textAlign: "left",
        backgroundColor: "#000000",
        marginTop: spV(40),
        paddingHorizontal: spH(55),
        paddingVertical: spV(55),
        display: "flex",
        flexDirection: "row",
    },

    textContainerStyle: {
        // backgroundColor: "green",
        marginTop: spV(16),
        fontSize: fp(22),
        fontWeight: "350",
        lineHeight: 42,
    },

    ImageTextContainer: {
        // backgroundColor: "pink",
        paddingTop: spV(10),
        // paddingBottom: spV(10),
        paddingLeft: spH(25),
        paddingRight: spH(0),
        width: "52%",
        margin: "auto",
        // width: wp(420),
    },

    founderHeadingText: {
        marginTop: spV(0),
        fontFamily: "LibreBodoni",
        fontSize: fp(28),
        fontWeight: "350",
        lineHeight: 32,
        width: wp(900),
        color: "white",
    },

    founderSubText: {
        fontFamily: "JosefinSans",
        marginTop: spV(15),
        fontSize: fp(16),
        fontWeight: "300",
        lineHeight: 28,
        color: "#FFFFFF",
    },

    aboutNewsContainer: {
        marginTop: spV(45),
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        alignContent: "center",
    },
    aboutNewsImageContainer: {
        // paddingRight: spH(6),
        // paddingLeft: spH(6),
        paddingHorizontal: spH(10),
        // alignItems: "center",
    },

    aboutNewsImage: {
        width: wp(373.33333),
        height: wp(373.33333),
    },
    aboutNewsText: {
        fontSize: fp(16),
        fontWeight: "350",
        lineHeight: "140%",
        textAlign: "left",
        marginTop: spV(8),
        width: 365,
        // paddingRight: spH(10),
    },
});
